import { createUseGesture, dragAction, pinchAction } from '@use-gesture/react';
export var useDragAndPinch = createUseGesture([dragAction, pinchAction]);
